<template>
  <div class="common-footer" id="J_CommonFooter" style="display:none;">
    <footer>
        <div class="footer-container">
          <ul class="footer-info">
            <li id="J_CopyRight"></li>
            <li><a href="javascript:;" id="J_LawLink"></a></li>
          </ul>
        </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'common-footer',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Footer.vue?08cb4e52